"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELigneMetierTrads = void 0;
exports.ELigneMetierTrads = {
    assurance: "Assurance",
    banque: "Banque",
    cif: "CIF",
};
